import axios from "axios";
import { env } from "../config";
export default axios.create({
  withCredentials: true,
  baseURL:
    env === "local"
      ? "http://localhost:8000/api"
      : env === "dev"
      ? "https://testapps-api.trainery.one/api"
      : "https://apps-api.trainery.one/api",
});
